<template>
  <div class="ceramic relative texture-bg-css">
    <div class="w">
      <div class="page-header"><Breadcrumb /></div>
      <div class="w-full t-content">
        <div v-if="properties && defaults" class="text-left t-conditions">
          <div>
            <ul
              class="t-condition-classify"
              v-for="(property, key) in properties"
              :key="key"
            >
              <li class="clearfix relative">
                <div class="t-condition-name cursor-default">
                  {{ property.description }}
                </div>
                <ul class="t-condition-options clearfix">
                  <li
                    v-for="item in defaults[key]"
                    :key="item.name"
                    :class="item.checked ? 'active' : ''"
                    @click="conditionChecked(item, key)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="text-center t-conditions">暂无数据</div>
        <div class="text-center t-lists">
          <ceramicsContent :data="conditions" :uuid="uuid"></ceramicsContent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import ceramicsContent from '@/components/ceramics/CeramicsContent'

export default {
  name: 'ceramic',
  components: {
    Breadcrumb,
    ceramicsContent
  },
  data() {
    return {
      ceramics: null,
      properties: {},
      defaults: null,
      conditions: {},
      uuid: null
    }
  },
  watch: {
    schemaConfig() {
      this.getConditions() // 编辑瓷器搜索条件
    }
  },
  computed: {
    schemaConfig() {
      return this.$store.getters['SchemaConfigStore/schemaConfig']
    },
    emptyConditions() {
      let conditions = JSON.parse(
        JSON.stringify(this.schemaConfig.properties.ceramic.default)
      )
      for (let key in conditions) {
        conditions[key] = []
      }
      return conditions
    }
  },
  mounted: function() {
    this.getConditions() // 编辑瓷器搜索条件
  },
  methods: {
    // 条件的选中事件
    conditionChecked(item, key) {
      if (!this.defaults[key]) {
        return false
      }
      let current = this.conditions[key] ? this.conditions[key] : []

      if (item.name === '全部') {
        current = []
      } else {
        let index = current.indexOf(item.name)

        if (index === -1) {
          current = []
          current.push(item.name)
        } else {
          current.splice(index, 1)
        }
      }

      if (current.length === this.defaults[key].length - 1) {
        current = []
      }
      if (current.length > 0) {
        this.defaults[key].map(condition => {
          if (current.indexOf(condition.name) === -1) {
            condition.checked = false
          } else {
            condition.checked = true
          }
          return condition
        })
      } else {
        this.defaults[key] = this.defaults[key].map(condition => {
          if (condition.name === '全部') {
            condition.checked = true
          } else {
            condition.checked = false
          }
          return condition
        })
      }
      this.conditions[key] = current
      this.conditions = JSON.parse(JSON.stringify(this.conditions))
      this.$nextTick(() => {
        this.$router.push({
          path: '/ceramic',
          query: this.conditions
        })
      })
    },
    // 获取瓷器搜索条件
    getConditions() {
      let conditions = this.$route.query // 获取url的参数
      if (conditions.uuid) {
        this.uuid = conditions.uuid
      }
      if (
        !this.schemaConfig ||
        !this.schemaConfig.properties ||
        !this.schemaConfig.properties.ceramic
      ) {
        return false
      }
      this.properties = Object.assign(
        {},
        this.schemaConfig.properties.ceramic.properties
      )
      let defaults = Object.assign(
        {},
        this.schemaConfig.properties.ceramic.default
      )

      for (let key in defaults) {
        defaults[key] = defaults[key].map(item => {
          return { name: item, checked: false }
        })
        defaults[key].unshift({ name: '全部', checked: true })
      }
      this.defaults = defaults
      for (let index in conditions) {
        if (Array.isArray(conditions[index])) {
          conditions[index].forEach(value =>
            this.conditionChecked({ name: value }, index)
          )
        } else {
          this.conditionChecked({ name: conditions[index] }, index)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.ceramic {
  min-height: 80vh;
  .t-conditions {
    margin-top: 30px;
    margin-bottom: 50px;
    padding: 26px 36px;
    background-color: $c-ceramic-search-bg;
    > div {
      border-top: 1px solid $c-ceramic-border;
    }
  }
  .t-condition-classify {
    padding: 7px 0;
    border-bottom: 1px solid $c-ceramic-border;
    li {
      padding-left: 100px;
    }
  }
  .t-condition-name {
    color: $c-white;
    font-size: 14px;
    position: absolute;
    left: 0;
    top: 10px;
    padding-right: 22px;
    border-right: 1px solid $c-white;
    margin-top: 2px;
  }
  .t-condition-options {
    li {
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      color: $c-white;
      float: left;
      width: 125px;
      padding: 0 5px;
      margin-right: 5px;
      line-height: 40px;
      background-size: auto 0;
      background-position: center;
      &:first-child {
        margin-bottom: 1px;
      }
      &.active,
      &:hover {
        transition: all 0.35s;
        -moz-transition: all 0.35s;
        -webkit-transition: all 0.35s;
        -o-transition: all 0.35s;
      }
      &:hover {
        color: $c-hover;
      }
      &.active {
        background: url('../../../static/images/ceramic/ceramic-condition-checked.png')
          center no-repeat;
        background-size: auto 28px;
      }
    }
  }
  ::v-deep  .pag {
    padding: 35px 0 80px 0;
  }
}
</style>
